import React, { useState } from 'react';
const LensPowerCalculator = () => {
  const [focalLength, setFocalLength] = useState('');
  const [lensPower, setLensPower] = useState('');
  const [explanation, setExplanation] = useState('');
  const [error, setError] = useState('');
  const handleCalculate = () => {
    if (!focalLength) {
      setError('Please enter the focal length (F)');
      setLensPower('');
      setExplanation('');
      return;
    }
    const focalLengthValue = parseFloat(focalLength);
    if (isNaN(focalLengthValue)) {
      setError('Please enter a valid focal length value');
      setLensPower('');
      setExplanation('');
      return;
    }
    const lensPowerValue = 1 / focalLengthValue;
    setLensPower(lensPowerValue.toFixed(2));
    const lensType = lensPowerValue > 0 ? 'Convex Lens' : 'Concave Lens';
    setExplanation(
      `Lens Power (C) = 1 / Focal Length (F) = 1 / ${focalLengthValue} = ${lensPowerValue.toFixed(2)}\n\n` +
      `Since the lens power is positive (+), this is a ${lensType}.`
    );
    setError('');
  };
  return (
    <div dir="ltr">
      <div>
        <input
          type="number"
          placeholder="Focal Length (F)"
          value={focalLength}
          onChange={(e) => setFocalLength(e.target.value)}
          className="form-control"
          style={{ width: '300px' }}
        />
        <br/>
        <button
          className="btn btn-success"
          style={{ fontSize: '20px' }}
          onClick={handleCalculate}
        >
          Calculate Lens Power
        </button>
      </div>
      <br />
      <div>
        {error !== '' ? (
          <p className='p-3 mb-2 bg-warning text-white'>Error: {error}</p>
        ) : (
          <>
            {lensPower !== '' && (
              <>
                <p className='p-3 mb-2 bg-success text-white'>
                  Lens Power (C): {lensPower}
                </p>
                {explanation !== '' && (
                  <p className='p-3 mb-2 bg-info text-black'>
                    Calculation Steps: <br/>{explanation}
                  </p>
                )}
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};
export default LensPowerCalculator;
